import React from 'react';
import PropTypes from 'prop-types';
import utilFunction from '../../../containers/function';

const SimpleIndicator = props => (
  <section className={'simple-indicator'}>
    <div
      style={{
        fontSize: props.fontSize,
        color: utilFunction.getColorCategory(props.graphColorRange, props.value)
      }}
    >
      <span>{utilFunction.getFormatFunction(props.valueFormat)(props.value)}</span>
    </div>
  </section>
);

export default SimpleIndicator;



// WEBPACK FOOTER //
// ./source/client/components/common/indicators/simpleIndicator.jsx